import React from 'react';
import { Card } from 'react-bootstrap'
import { Form, SelectPicker, Table } from 'rsuite';
import RedStar from '../../../../../Shared/GenericComponents/RedStar';
import { AccessibleSelectPicker } from '../../../../../Shared/GenericComponents/AccessibleComponents';
function LicenseStatus(props) {

    return (
        <div className="peRenewalLicenseStatus">
            <Card>
                <Card.Header><h6>Your License Status</h6></Card.Header>
                <Card.Body>
                    <Card>
                        <Card.Body>
                            <Table wordWrap autoHeight data={props.gridData} >
                                <Table.Column flexGrow={1}>
                                    <Table.HeaderCell>
                                        <b>Credential</b>
                                    </Table.HeaderCell>
                                    <Table.Cell dataKey="credential" />
                                </Table.Column>
                                <Table.Column flexGrow={1}>
                                    <Table.HeaderCell>
                                        <b>Credential Status</b>
                                    </Table.HeaderCell>
                                    <Table.Cell dataKey="credentialStatus" />
                                </Table.Column>
                            </Table>
                        </Card.Body>
                    </Card>
                    <br />
                    <Card>
                        <Card.Body>
                            <Form.Group>
                                <Form.ControlLabel>
                                    <strong>I am renewing into the following status:<RedStar /></strong>
                                </Form.ControlLabel>
                                <Form.Control
                                    accepter={AccessibleSelectPicker}
                                    ariaLabel="Renewing into status"
                                    placeholder="Select Status"
                                    searchable={false}
                                    block
                                    readOnly={props.isReadOnly}
                                    data={props.peRenewalLicenseStatuses}
                                    name="renewingTo" />
                                <Form.HelpText className="d-none">Renewing into status</Form.HelpText>
                            </Form.Group>
                        </Card.Body>
                    </Card>
                </Card.Body>
            </Card>
        </div>
    );
}

export default LicenseStatus;